import { runFullJiraSync } from '../../services/jiraSync';
import { emailToDevIdMap, projectKeyToClientMap, withRemap } from './syncMaps';

/* Synchro complète projet par projet (un appel serveur par projet, bien plus fiable que l'ancienne
   orchestration navigateur qui multipliait les allers-retours), avec avancement affiché. Renvoie
   les totaux et les worklogs non rattachés, pré-remplis pour la résolution. */
export async function syncAllProjects({
  projectKeys,
  fromMonth,
  toMonth,
  clients,
  adminUsers,
  setYearImportModal,
}) {
  const emailToDevId = emailToDevIdMap(adminUsers);
  const projectKeyToClient = projectKeyToClientMap(clients);
  setYearImportModal({ loading: true, done: 0, total: projectKeys.length, current: '' });
  const totals = { inserted: 0, updated: 0, deleted: 0, skipped: 0, unmatched: [] };
  for (let i = 0; i < projectKeys.length; i++) {
    const projectKey = projectKeys[i];
    setYearImportModal((s) => ({ ...s, done: i, current: projectKey }));
    const { data, error } = await runFullJiraSync(fromMonth, projectKey, toMonth);
    if (error || !data || data.error) continue;
    for (const k of ['inserted', 'updated', 'deleted', 'skipped']) totals[k] += data[k] || 0;
    for (const u of data.unmatched || [])
      totals.unmatched.push(withRemap(u, emailToDevId, projectKeyToClient));
  }
  return totals;
}
